import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BuyersEditIbanDialogComponent } from 'src/app/buyers/buyers-edit-iban-dialog/buyers-edit-iban-dialog.component';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { QineticPaymentSource } from 'src/app/core/qinetic-payment-sources.service';

@Component({
  selector: 'app-buyer-details-general-sdd',
  templateUrl: './buyer-details-general-sdd.component.html',
  styleUrls: ['./buyer-details-general-sdd.component.scss'],
})
export class BuyerDetailsGeneralSddComponent {
  @Input() buyer_id?: string;
  @Input() sdd_payment_sources?: QineticPaymentSource[];
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly dialog_service: DialogService, private readonly error_service: ErrorService) {}

  onEditIbanClick(payment_source?: QineticPaymentSource): void {
    this.dialog_service
      .openDialog(BuyersEditIbanDialogComponent, {
        buyer_id: this.buyer_id,
        buyer_qinetic_payment_source_id: payment_source?.buyer_qinetic_payment_source_id,
        iban: payment_source?.qinetic_sepa_debit?.iban,
      })
      ?.afterClosed()
      .subscribe(dialog_result => {
        if (dialog_result?.success) {
          this.refresh.emit();
        }

        if (dialog_result?.error) {
          const processed_error: SplittypayError = dialog_result.error;
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
      });
  }
}
